import { render, staticRenderFns } from "./EditResellerInvoiceComponent.vue?vue&type=template&id=06e99c6d"
import script from "./EditResellerInvoiceComponent.vue?vue&type=script&lang=js"
export * from "./EditResellerInvoiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports